import React from 'react';
import classnames from 'classnames';
import * as styles from './styles.module.scss';
import Button from 'components/UI/Button';
import Icon from 'components/UI/Icon';

const Ecosystem = () => (
  <div className={styles.ecosystem}>
    <div className={styles.ecosystem_bg}></div>
    <div className={classnames('cr-wrap', styles.ecosystem_inner)}>
      <div className={styles.ecosystem_inner_l}>
        <div className={styles.ecosystem_txt}>
          <h2 className={classnames('cr-h2', styles.ecosystem_txt_title)}>
            An ecosystem for your sales management
          </h2>
          <p className={classnames('cr-lead', styles.ecosystem_txt_desc)}>
            Complete Business Solution around the point of sale, back office
            (merchandise management) as well as head office.
          </p>

          <Button
            className={classnames(
              'cr-btn--icon cr-btn--large cr-btn--wide cr-btn--icon-red-bg',
              styles.ecosystem_txt_btn
            )}
          >
            Request product tour
            <Icon name="corner-arrow-small-bold" />
          </Button>
        </div>
      </div>
      <div className={styles.ecosystem_inner_r}>
        <div className={styles.ecosystem_graphics}></div>

        <Button
          className={classnames(
            'cr-btn--icon cr-btn--large cr-btn--wide cr-btn--icon-red-bg',
            styles.ecosystem_inner_r_btn
          )}
        >
          Request product tour
          <Icon name="corner-arrow-small-bold" />
        </Button>
      </div>
    </div>
  </div>
);

export default Ecosystem;
